import axios from 'axios';
import { apiHost } from '../../config';

const clientSupplier = axios.create({ baseURL: apiHost });

export { clientSupplier };